var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgPlate = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58.625,
    height: 58.625,
    viewBox: "0 0 58.625 58.625",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1040.687 -244.687)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M19.883,0A19.883,19.883,0,1,1,0,19.883",
    transform: "matrix(0.602, -0.799, 0.799, 0.602, 1042.155, 277.913)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M19.883,0A19.883,19.883,0,1,1,0,19.883",
    transform: "matrix(-0.616, -0.788, 0.788, -0.616, 1066.573, 301.909)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M14,0A14,14,0,0,1,28,14",
    transform: "translate(1056.429 289.056) rotate(-92)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M14,28A14,14,0,0,1,0,14",
    transform: "matrix(0.208, -0.978, 0.978, 0.208, 1053.275, 284.769)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M265.67,124.77l-.591-1.946a4.227,4.227,0,0,0-8.005,0l-.591,1.946a10.93,10.93,0,0,0-.3,5.065,4.764,4.764,0,0,0,2.453,3.32l-.662,14.8a2.917,2.917,0,0,0,.737,2.267,3.217,3.217,0,0,0,4.545.2q.106-.1.2-.2a2.877,2.877,0,0,0,.737-2.206l-.666-14.866a4.763,4.763,0,0,0,2.45-3.318A10.931,10.931,0,0,0,265.67,124.77Zm-1.509,4.745a2.92,2.92,0,0,1-1.911,2.2.921.921,0,0,0-.6.9l.7,15.547a1.065,1.065,0,0,1-.276.834,1.423,1.423,0,0,1-2,0,1.105,1.105,0,0,1-.271-.9l.694-15.486a.921.921,0,0,0-.6-.9,2.92,2.92,0,0,1-1.911-2.2,9.082,9.082,0,0,1,.253-4.205l.591-1.947a2.388,2.388,0,0,1,4.48,0l.591,1.947A9.094,9.094,0,0,1,264.16,129.514Z",
    transform: "translate(974.093 0.743) rotate(45)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plate.d0c0881e.svg";
export { ForwardRef as ReactComponent };